import { useEffect, useState } from "react";
import { API } from "@/lib/api";

const imgSrc = (u) => (u?.startsWith("/api") ? `${API.replace("/api", "")}${u}` : u);

export default function SponsorMarquee() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    fetch(`${API}/sponsors`)
      .then((r) => r.json())
      .then((d) => setSponsors(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  if (!sponsors.length) return null;

  const strip = (
    <div className="flex shrink-0 items-center">
      {sponsors.map((s) => {
        const card = (
          <div className="mx-4 bg-white/95 px-8 py-4 flex items-center justify-center h-20 w-52 shrink-0">
            <img src={imgSrc(s.logo)} alt={s.name} className="max-h-12 max-w-full object-contain" loading="lazy" />
          </div>
        );
        return s.link ? (
          <a key={s.id} data-testid="sponsor-marquee-item" href={/^https?:\/\//i.test(s.link) ? s.link : `https://${s.link}`} target="_blank" rel="noopener noreferrer" className="shrink-0 hover:opacity-80 transition-opacity" title={s.name}>
            {card}
          </a>
        ) : (
          <div key={s.id} data-testid="sponsor-marquee-item" className="shrink-0" title={s.name}>
            {card}
          </div>
        );
      })}
    </div>
  );

  return (
    <section data-testid="sponsor-marquee" className="border-y border-clay-border bg-clay-surface/60 py-8 overflow-hidden">
      <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-clay-muted text-center mb-5">
        Proudly backed by our track sponsors
      </p>
      <div className="relative">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {strip}
          {strip}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-clay-bg to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-clay-bg to-transparent pointer-events-none" />
      </div>
    </section>
  );
}
